import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['jumpitem'];
    
    toggleNarrative() {
        document.body.classList.toggle('show-narrative');
    }

    closeNarrative() {
        document.body.classList.remove('show-narrative');
    }
/*
    jumpitemTargetConnected(jumpitem) {
        console.debug(jumpitem.getAttribute('href'));
        const href = jumpitem.getAttribute('href');

        if (null === href.match(/^#/)) {
            return;
        }

        const updateActiveState = (function updateActiveState() {
            document.querySelectorAll(href).forEach((target) => {
                const speakerRect = target.getBoundingClientRect();
                const targetTop = speakerRect.top + document.body.scrollTop;
                const targetBottom = targetTop + target.offsetHeight;

                console.debug([href, targetTop, targetBottom]);
            });
            
            window.requestAnimationFrame(updateActiveState);
        })();
    }

    connect() {
        const updateActiveState = (function updateActiveState() {



            document.querySelectorAll(href).forEach((target) => {
                const speakerRect = target.getBoundingClientRect();
                const targetTop = speakerRect.top + document.body.scrollTop;
                const targetBottom = targetTop + target.offsetHeight;

                console.debug([href, targetTop, targetBottom]);
            });
            
            window.requestAnimationFrame(updateActiveState);
        })();
    }
*/
}
